import { useEffect, useRef, MutableRefObject } from 'react';

/**
 * @desc 初始化计算各项宽、设置滚动锁
 */
export const useComputedTabWidth = () => {
    // 滚动容器
    const contentRef = useRef<HTMLDivElement | null>(null);
    // tab 容器
    const chooseTabRef = useRef<HTMLDivElement | null>(null);
    // Look 加锁，判断超出是否需要滚动；true-禁止滚动，false-滚动
    const look = useRef<null | boolean>(null);
    // 子项的宽度
    const tabWidths = useRef<number[]>([]);

    useEffect(() => {
        if (contentRef.current && chooseTabRef.current) {
            const tabItemWidth = [];
            const childNodes: NodeList = chooseTabRef.current.childNodes;
            for (let i = 0; i < childNodes.length; i++) {
                const node = childNodes[i] as HTMLDivElement;
                if (node.attributes.getNamedItem('title')) tabItemWidth.push(node.clientWidth);
            }
            // 子项宽度
            tabWidths.current = tabItemWidth;
        }
    }, []);

    return {
        contentRef,
        chooseTabRef,
        look,
        tabWidths,
    };
};

/**
 * @desc 计算左偏移量
 */
export const useComputedLeftOffset = (tabWidths: MutableRefObject<number[]>, contentRef: MutableRefObject<HTMLDivElement | null>) => {
    // tab 容器滚动左偏移量
    const offsetItems = useRef<number[]>([]);
    useEffect(() => {
        offsetItems.current = tabWidths.current.reduce(
            (preArray: number[], _clientWidthItem: number, clientWidthIndex: number, originArr: number[]) => {
                console.log('clientWidthIndex====', preArray, clientWidthIndex, originArr.length);
                if (clientWidthIndex === 0) return preArray;
                const offsetValue = originArr[clientWidthIndex - 1] + preArray[preArray.length - 1];
                return preArray.concat(offsetValue);
            },
            // 初始值，第一项偏移为 0
            [0],
        );
    }, []);
    return {
        offsetItems,
    };
};

/**
 * @desc 计算下标线位置
 */
export const useComputedLinePos = (tabWidths: MutableRefObject<number[]>, look: MutableRefObject<null | boolean>) => {
    // 高亮下标线位置
    const linePos = useRef<number[]>([]);

    useEffect(() => {
        if (look.current === true) return;
        linePos.current = tabWidths.current.reduce(
            (preArray: number[], _clientWidthItem: number, clientWidthIndex: number, originArr: number[]) => {
                if (clientWidthIndex === 0) return preArray;
                const offsetValue = originArr[clientWidthIndex - 1] + preArray[preArray.length - 1];
                return preArray.concat(offsetValue);
            },
            // 初始值，第一项偏移为 0
            [0],
        );
    }, []);

    return {
        linePos,
    };
};
